import {useState,useEffect, useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { saleServices } from "../../services/saleServices";
import { Dialog } from 'primereact/dialog';
import {Titlebar,Searchbox,Orderstatus} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Toast } from "primereact/toast";
import { TabMenu } from 'primereact/tabmenu';
import {formatCurrency} from '../../helpers/formatCurrency';
import {Shopifyordersfetch} from '../../components/artifacts/shopifycomp'; 

const Salesfullfilment = () =>{
    const toast = useRef(null);
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [activeIndex, setActiveIndex] = useState(6);
    const [filters, setFilters] = useState({'currentPage':'1','pageSize':'10','status':'Recently Added'});
    const [visible, setVisible] = useState(false);
    const [stockdialog, setStockDialog] = useState(false);
    const [detailinfo, setDetailinfo] = useState({});
    const [statusReasonDialog, setStatusReasonDialog] = useState(false);
    const [returnReason, setReturnReason] = useState('');
    const [newStatus, setNewStatus] = useState('');
    const [selectedID, setSelectedID] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [reallocationmodalVisible, setReallocationModalVisible] = useState(false);
    const [selectUpdateId, setSelectUpdateId] = useState(null);
    const [stockdatas, setStockdatas] = useState([]);
    const [warehousedataload, setwarehousedataload] = useState(false);
    const [reallocationstocks, setReallocationstocks] = useState([]);
    const [reallocatted, setReallocated] = useState({});
    const [paymentStatus, setPaymentStatus] = useState('');
    const [selectedreallocatted, setSelectedReallocatedItem] = useState({});
    const [paymentSelectedId, setPaymentSelectedId] = useState('');
    // const [shopifyData, setShopifyData] = useState({});
    const [colDefs, setColDefs] = useState([
    { headerName: "SR NO",field: "id",width:100

     },
    { headerName: "Order Id",field: "order_id" },
    // { headerName: "SKU Code",field: "sku_code",cellRenderer: (params) => {
    //     return (
    //         <Tag severity="success" value={params.getValue()} rounded></Tag>
         
    //     );
    //   } },
    { headerName: "Sales Channel",field: "sales_channel",cellStyle: { 'white-space': 'normal' }, },
    { headerName: "Product Sold",field: "product_sold" },
    { headerName: "Date",field: "sales_date_str" },
    { headerName: "Units Sold",field: "total_units_sold" },
    { headerName: "SKU Code",field: "sku_code" },
    { headerName: "Freight Cost",field:"freight_charges"},
    { headerName: "PUSP",field: "sales_price" },
    { headerName: "Total Sales",field: "total_sales_price",cellRenderer: (params) => {
        return (
          <>
             {params.data.total_sales_price}
          </>
        )} },
    // { headerName: "Freight Charges",field: "freight_charges" },
    // { headerName: "Royalties",field: "royalties" },
    { headerName: "Stock \n Updation",
      cellRenderer: (params) => {
        return (
          <>
           {params.data.order_status == 'Returned' ? (<button className="btn btn-info btn-xs btn-white btn-border-none" onClick={()=> { setStockUpdation(params)}}>Stock Update</button>) : (<></>)}
            
          </>
        )
      } },
      { headerName: "Payment Status",
      field: "payment_status",
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: ['Fully paid','Partially paid','Unpaid']
      },
      cellRenderer: (params) => {
        // console.log("Params from inside the cellRenderer: ", params);
          return (
            params.data.order_status == 'Returned' ? <>Returned</> :
              <>
              {/* <Orderstatus status={params.getValue()} /> */}
                <select  className='rounded w-100 text-primary dropdown-custom-style' value={params.getValue()} onChange={(e) => { setSelectedPaymentStatus(params, e.target.value) }} disabled={params.getValue() == 'closed' ? true : false}>
                  <option value="Fully paid">Fully Paid</option>
                  <option value="Partially paid">Partially Paid</option>
                  <option value="Unpaid">Unpaid</option>
                </select>
              </>
          );
      } 
    },
    { headerName: "Order Status",
      field: "order_status",
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: ['Confirmed','Cancelled','Packed','Shipped', 'Delivered','Over Stock']
      },
      cellRenderer: (params) => {
        // console.log("Params from inside the cellRenderer: ", params);
          return (
            params.data.order_status == 'Returned' ? <>Returned</> :
              <>
              {/* <Orderstatus status={params.getValue()} /> */}
                <select  className='rounded w-100 text-primary dropdown-custom-style' value={params.getValue()} onChange={(e) => { setSalesStatus(params, e.target.value) }} disabled={params.getValue() == 'closed' ? true : false}>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Packed">Packed</option>
                  <option value="Shipped">Shipped</option>
                  <option value="Delivered">Delivered</option>
                  <option value="Closed">Closed</option>
                  <option value="Returned">Returned</option>
                </select>
              </>
          );
      } 
    },
    
    
    { headerName: "Action",
    cellRenderer: (params) => {
      // console.log("params");
      // console.log(params.data.id);
      return (
        <>
             {
                params.data.stock_reupdated == 'Yes' ? <></> : (<button class="btn btn-success btn-xs btn-white btn-border-none"><i class="icon icon-eye text-white" onClick={() => { setStockDialog(true); setDetailinfo(params.data); getdetailinfo(params);wareHouses(params.data)}}></i></button> )  
             }
             &nbsp; 
            {params.data.order_status != 'Delivered' ? (
              <>
              <button class="btn btn-primary btn-xs btn-white " onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note color-white"></i></button>&nbsp;
              <button class="btn btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletesale(params.data.id)}><i class="icon icon-trash text-white" ></i></button>
              </>
              ) : <></> }
             
            
        </>
      );
    } }
  ]);


  const getAvailableStock = ({order_id,product_id,warehouse_code}) => {
      saleServices.getAvailableStock({order_id,product_id,warehouse_code}).then((response)=>{
          console.log("available stock response");
          console.log(response.data.data);
          if(response.status == 200){ 
              setReallocationstocks(response.data.data);
              // return response.data.available_stock;
          }else{
              setReallocationstocks([]);
              // return 0;
          }
      }).catch((error)=>{
          return 0;
      });
    }


  const wareHouses = (params) =>{
     console.log(params.sku_code);
     console.log(params.stock_id);
     let array = [];
     setwarehousedataload(true);
      saleServices.getWareHouseLocation(params.order_id).then((response) => { 
        if(response.status == 200){
          response.data.data.forEach((element,index) => {
              array.push(<tr>
                        <td>{index + 1}</td>
                         <td>{element.name}</td>
                        <td>{element.contact_person}</td>
                        <td>{element.email}</td>
                        <td>{element.phone}</td>
                        <td>{element.address}</td>
                        <td>{element.city}</td>
                        <td>{element.state}</td>
                        <td>{element.postal_code}</td>
                        <td>{element.country}</td>
                        <td>{element.capacity}</td>
                        <td><div className='flex-box'><span style={{background:'#e5eeff',padding:'10px'}}>{element.units_sold}</span> 
                                <span><button
                                    type="button"
                                    className="btn color-white w-100 rounded custom-btn-color-secondary"
                                     onClick={() => {setReallocationModalVisible(true);getAvailableStock({order_id:params.order_id,product_id:params.sku_code,warehouse_code:element.warehouse_code});setReallocated(element)}}
                                    >
                                    Reallocate
                                  </button></span></div></td>
                        

                        </tr>);
          });
          setStockdatas(array);
          setwarehousedataload(false);
          console.log("The warehouse location response is : ", response); 
        }else{
          setStockdatas([]); 
          setwarehousedataload(false);
        }   
     });
  }

  const getRowClass = params => {
    if (params.data.status === 'dispatched') {
      return 'dispatched';
    } else if (params.data.status === 'partially_received') {
      return 'partially_received';
    } else if (params.data.status === 'fully_received') {
      return 'fully_received';
    }
    return '';
  };

  const setStockUpdation = (params) => {
    setSelectUpdateId(params);
    console.log("The stock update params are : ", params);

    setModalVisible(true);

  }

  const updateStock = () => {
    console.log("Update stock params :", selectUpdateId);
      saleServices.updateReturnedStock({
      stock_id: selectUpdateId.data.id,
      order_id: selectUpdateId.data.order_id,
      units_sold: selectUpdateId.data.units_sold,
      sku_code: selectUpdateId.data.sku_code
    }).then((response) => {
      if(response.status == 200){
        toast.current.show({severity:'success', summary: 'Stock updated', detail:'Stock Updated Successfully'});
      }
    }).catch((error) => {
      console.log(error);
      toast.current.show({severity:'error', summary:'Stock not updated', detail:'Stock Update Failed '});
    })
  }

  const setSalesStatus = (params, newStatus) => {
  
    if(newStatus == 'Returned'){
      // modalRef.current.show();
      console.log("The returned product ID is : ", params.data.id);
      setNewStatus(newStatus);
      setSelectedID(params.data.id);
      setStatusReasonDialog(true);

      setReturnReason('');
    }else{
      setStatusApi(params.data.id, newStatus, '');
    }
  
  }

  const setSelectedPaymentStatus = (params, newStatus) => {
     
    // modalRef.current.show();
    console.log("The returned product ID is : ", params.data.id);
    setPaymentStatus(newStatus);
    setPaymentSelectedId(params.data.id);

    setPaymentStatusApi(params.data.id, newStatus, '');
  }

  const SubmitButtonClicked = () => {

        console.log("Submit Clicked ", selectedID, newStatus, returnReason );
        if(!returnReason || returnReason.trim() === ''){
          toast.current.show({severity:'error', summary: 'Return Reason', detail: 'Return Reason is required'});
          setStatusReasonDialog(false);
          return;
        }

        setStatusApi(selectedID, newStatus, returnReason);
  }

  const setStatusApi = (selectedID, newStatus, returnReason)  => {
     saleServices.updateStatus(
      {
        id: selectedID,
        order_status: newStatus,
        return_reason: returnReason ?? ''
      }
     ).then((response) => {
        if(response.status == 200){
          toast.current.show({severity:'success', summary: 'Status Updated', detail:'Status Updated Successfully'});
          getsalelist(filters.currentPage, filters.pageSize,filters.status);
        }else if(response.data?.data == 'Only Delivered orders can be returned'){
          toast.current.show({severity:'error', summary: 'Status Update Failed', detail: 'Only Delivered orders can be returned'});
        }
      }).catch((error)=>{
        console.log(error);
      
      })

  }

  const setPaymentStatusApi = (selectedID, newStatus)  => {
      saleServices.updatePaymentStatus(
        {
          id: selectedID,
          payment_status: newStatus,
        }
      ).then((response) => {
          if(response.status == 200){
            toast.current.show({severity:'success', summary: 'Payment Status Updated', detail:'Status Updated Successfully'});
            getsalelist(filters.currentPage, filters.pageSize,filters.status);
          }else if(response.data?.data == 'Only Delivered orders can be returned'){
            toast.current.show({severity:'error', summary: 'Status Update Failed', detail: 'Only Delivered orders can be returned'});
          }
        }).catch((error)=>{
          console.log(error);
        
        })

    }


  useEffect(()=>{
     getsalelist(filters.currentPage, filters.pageSize,filters.status); 
  },[])

   const opendialog = () => {
    setVisible(true);
  };

  const getdetailinfo = (data) => {
    console.log(data);
  }

  const editredirect = (id,saleData) =>{
    navigate(`/editsale/${id}`, { state: { sale: saleData } });
  }
  const deletesale = (id) =>{
            saleServices.deletesale(id).then((response)=>{
            if(response.status == 200){
              toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Sale deleted successfully' }); 
              getsalelist();   
            }
        }).catch((error)=>{
          
        }); 
  }


  const getsalelist  = (page, pageSize,status='All')=> {
        setUserloaded(true);
        saleServices.getsaledata(page, pageSize,status).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data.data);
                setUserloaded(false);
                 setTotalRows(response.data.data.total);
                setCurrentPage(response.data.data.current_page);
            }else{
              setResults([]);
                // setUsers([]);
                 setUserloaded(false);
            }  
        }).catch((error)=>{
          setResults([]);
            // setUsers([]);
            // setUserloaded(true);
        }); 
  } 

  const addproductnavigate = () =>{
    // navigate.  
    navigate('/addsale');
  }
  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:currentPage + 1
         } 
      });
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:currentPage - 1
         } 
      });
    }
  };
  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:newPage
         } 
      });
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    // getsalelist( 1, newSize);
    setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:1
         } 
    });
    
  };
    const items = [
   
    {
      label: 'All Sales',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('All'),
    },
    // {
    //   label: 'Open',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('Open'),
    // },
    // {
    //   label: 'Confirmed',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('Confirmed'),
    // },
    // {
    //   label: 'Packed',
    //   icon: 'fa fa-angle-right',
    //   command: () => handleStockFilter('Packed'),
    // },
    {
      label: 'Shipped',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Shipped'),
    },
    {
      label: 'Delivered',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Delivered'),
    },
    {
      label: 'Closed',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Closed'),
    },
    {
      label: 'Cancelled',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Cancelled'),
    },
    {
      label: 'Returned',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Returned'),
    },
    {
      label: 'Recently Added',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Recently Added'),
    }
  ];
  function handleStockFilter(status) {
    
     setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:1,
            status:status
         } 
      });   
    // getsalelist(1,pageSize,status);
  }

  useEffect(()=>{
       getsalelist(filters.currentPage, filters.pageSize,filters.status);       
    },[filters])

  const handleExport = () => {
     exportToExcel({ data: results, filename: 'stock' });
  }


  const reallocateStock = () => {
      // console.log("Reallocate stock params :", selectedreallocatted.allocatedQty);
      let emp_arr = [];
      Object.keys(selectedreallocatted.allocatedQty).forEach((batchId) => { 
        emp_arr.push({'batch_id':batchId,'allocated_quantity':selectedreallocatted.allocatedQty[batchId].value,'warehouse_allow':selectedreallocatted.allocatedQty[batchId].warehouseLocation}); 
      });
      console.log("The final array to send is : ", emp_arr);
      console.log("Reallocated data :",reallocatted);
      saleServices.updateallocationdata({ 
        previous_allocation: reallocatted,
        new_allocation: emp_arr
      }).then((response) => {
        if(response.status == 200){
          // toast.current.show({severity:'success', summary: 'Allocation Updated', detail:'Allocation Updated Successfully'});
          // setReallocationModalVisible(false);
          // getsalelist(filters.currentPage, filters.pageSize,filters.status);
        }
      }).catch((error) => {
        // console.log(error);
        // toast.current.show({severity:'error', summary:'Allocation not updated', detail:'Allocation Update Failed '});
      });

  }

  // const callShopifyAPI = () => {
  //   saleServices.getShopifyData().then((response) =>{
  //     if(response.status){
  //       setShopifyData(response.data.data);
  //       console.log("Response from shopify data : ", shopifyData);
  //     }
  //   })
  // }

  function handleSelection(selected) {
     let unit_sold = reallocatted.units_sold; 
     let totalAllocated = 0;
     Object.keys(selected.allocatedQty).forEach((batchId) => { 
        totalAllocated = totalAllocated + selected.allocatedQty[batchId].value;
      });
    // console.log("Selected IDs:", selected);
    // console.log(reallocatted.units_sold);
    if(totalAllocated > unit_sold){
        toast.current.show({severity:'error', summary: 'Allocation Error', detail:'Allocated units cannot be more than units sold'});
        return;
    }
    setSelectedReallocatedItem(selected);
  }

  return(
       <>
        <Toast ref={toast} />
          {/* <Bredcrum title={'Sales Overiew'} divider={false}/> */}
          <div class="row">
            
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                      <div> <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-4 pe-4' onClick={() => addproductnavigate()}>Add New Sales</button> 
                      &nbsp;&nbsp;
                      <Shopifyordersfetch/></div>
                     
                     <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
                  </div> 
              </div> 

              {/* <Titlebar text={'Sales Overview'}/> */}
              <div className="col-md-12 mt-3">
                <div className='row'>
                      <div className='col-md-9'>
                        <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
                    </div> 
                     <div className='col-md-3'>
                        <div>
                          <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                            <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                        </div>
                      </div>
                </div>
               
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}  quickFilterText={quickFilterText} paginationPageSize={filters.pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={filters.pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange}
                getRowClass={getRowClass}
                />
                     </div>
                 </div>
              </div>   
          </div>

           <Dialog visible={stockdialog} position='top' modal style={{ width: '90rem' }} onHide={() => { if (!stockdialog) return; setStockDialog(false); }}>
              <div class="container">
                <table className='table-bordered'>
                  <tbody>
                    <tr>
                      <th colSpan={12}><h3 className='text-success'>Product Info : </h3></th>
                      
                    </tr>
                    <tr>
                      <th>Sr No</th>
                      <th>Order ID</th>
                      <th>Sales Channel</th>
                      <th>Product Sold</th>
                      <th>Date</th>
                      <th>Units Sold</th>
                      <th>SKU Code</th>
                      <th>Freight Cost</th>
                      <th>Frieght Providers Name</th>
                      <th>Per Unit Sales Price</th>
                      <th>Total Sales</th>
                      <th>Order Status</th>
                    
                    </tr>
                    <tr>
                      <td>{detailinfo.id}</td>
                      <td>{detailinfo.order_id}</td>
                      <td>{detailinfo.sales_channel}</td>
                      <td>{detailinfo.product_sold}</td>
                      <td>{detailinfo.sales_date_str} <span className='text-success'>({detailinfo.unit_of_measurement})</span></td>
                      <td><i className='fa fa-user-circle text-info'></i> &nbsp;{detailinfo.units_sold}</td>
                      <td> {detailinfo.sku_code}</td>
                      <td> {detailinfo.freight_charges}</td>
                      <td>{detailinfo.freight_providers_name}</td>
                      <td> {detailinfo.sales_price}</td>
                      <td> {detailinfo.total_sales_price}</td>
                      <td><i className='fa fa-map text-warning'></i> {detailinfo.order_status}</td>
                    </tr>
                  </tbody>
                </table>
                <br/>
                <span className='text-success'>Customer Address :</span>
                 <table border="1" cellpadding="8" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Billing Address</th>
                            <th>Shipping Address</th>
                          </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>{detailinfo.billing_address}</td>
                            <td>{detailinfo.shiping_address}</td>
                        </tr>
                    </tbody>
                </table>        
                <br/>
                <span className='text-success'>Ware house Choosen :</span>
                {warehousedataload  ? (<>Loading ...</>) :  
                  <table border="1" cellpadding="8" cellspacing="0">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Contact Person</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Postal Code</th>
                            <th>Country</th>
                            <th>Capacity</th>
                            <th>Unit Allocated</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stockdatas}
                    </tbody>
                </table>  }
              </div>
            </Dialog>
          
          <Dialog header="Return Reason" visible={statusReasonDialog} position='top' modal style={{width: '50rem'}} onHide={() => {if (!statusReasonDialog) return; setStatusReasonDialog(false); }}>
              <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                      <div className='form-group'>
                        <label> Reason For Return</label>
                        <textarea className='form-control' value={returnReason} onChange={(e) => setReturnReason(e.target.value)}></textarea>  
                        <div className="button-group mt-3 mb-3">
                          <button className="btn btn-success me-2" onClick={() => { SubmitButtonClicked()}} >Submit</button>
                          <button className="btn btn-danger" onClick={() => { setStatusReasonDialog(false)}}>Cancel</button>
                        </div>
                      </div>
                  </div>
              </div>
            </div>
          </Dialog>
          <Dialog header="Stock Updation" visible={modalVisible} position='top' modal style={{width: '70rem'}} onHide={() => {if (!modalVisible) return; setModalVisible(false);}}>
             <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                      <div className='form-group'>
                        <label>Reallocate  Stock tio this : </label>
                       
                        <div className="button-group mt-3 mb-3">
                          <button className="btn btn-success me-2" onClick={() => { updateStock()}} >Submit</button>
                          <button className="btn btn-danger" onClick={() => { setModalVisible(false)}}>Cancel</button>
                        </div>
                      </div>
                  </div>
              </div>
            </div>
          </Dialog>


          <Dialog header="Reallocation" visible={reallocationmodalVisible} position='top' modal style={{width: '90rem'}} onHide={() => {if (!reallocationmodalVisible) return; setReallocationModalVisible(false);}}>
             <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                      <div className='form-group'>
                        <label> Current Stock Allocated Warehouse</label>  
                        {reallocatted && 
                         <div>
                            <p>Order ID :  {console.log(reallocatted)}</p> 
                            </div> 
                        }
                        <table border="1" cellpadding="8" cellspacing="0">
                          <thead>
                              <tr>
                                  <th>ID</th>
                                  <th>Name</th>
                                  <th>Contact Person</th>
                                  <th>Email</th>
                                  <th>Phone</th>
                                  
                                  <th>City</th>
                                  <th>State</th>
                                  <th>Postal Code</th>
                                  <th>Country</th>
                                 
                                  <th>Unit Allocated</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td></td>
                                  <td>{reallocatted.name}</td>
                                  <td>{reallocatted.contact_person}</td>
                                  <td>{reallocatted.email}</td>
                                  <td>{reallocatted.phone}</td>
                                  <td>{reallocatted.city}</td>
                                   <td>{reallocatted.postal_code}</td>
                                  
                                  <td>{reallocatted.state}</td>
                                  <td>{reallocatted.country}</td>
                                  
                                  
                                   <td>{reallocatted.units_sold}</td>

                              </tr>
                          </tbody>
                          </table> 
                          <br/>
                        <label> Stock to warehouse to allocate</label>
                        <CheckboxList items={reallocationstocks} initialSelected={[102]} onChange={handleSelection}/>
                        <div className="button-group mt-3 mb-3">
                          <button className="btn btn-success me-2" onClick={() => { reallocateStock()}} >Submit</button>
                          <button className="btn btn-danger" onClick={() => { setReallocationModalVisible(false)}}>Cancel</button>
                        </div>
                      </div>
                  </div>
              </div>
            </div>
          </Dialog>
       </>
    );   
 }
 export default Salesfullfilment;

 export  function CheckboxList({ items = [], initialSelected = [], onChange }) {
  const [selected, setSelected] = useState(new Set(initialSelected));
  const [allocatedQty, setAllocatedQty] = useState({});


  function toggleItem(id) {
    setSelected(prev => {
      const copy = new Set(prev);

      if (copy.has(id)) {
        // REMOVE ITEM
        copy.delete(id);

        setAllocatedQty(q => {
          const newQ = { ...q };
          delete newQ[id];

          // Send updated state to parent
          onChange?.({
            selected: Array.from(copy),
            allocatedQty: newQ
          });

          return newQ;
        });

      } else {
        // ADD ITEM
        copy.add(id);

        // Send updated state to parent (no change in qty yet)
        onChange?.({
          selected: Array.from(copy),
          allocatedQty
        });
      }

      return copy;
    });
  }

  function handleQtyChange(batchId, value, warehouseLocation) {
    setAllocatedQty(prev => {
      const updated = {
        ...prev,
        [batchId]: { value, warehouseLocation }
      };

      // Send updated allocations
      onChange?.({
        selected: Array.from(selected),
        allocatedQty: updated
      });

      return updated;
    });
  }



  return (
    <div className="checkbox-list">
      {items.map((item) => {
        const checkboxId = `checkbox-${item?.batch_number}`;

        return (
          <label key={item.batch_number} htmlFor={checkboxId} className="checkbox-item" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <table>
                <thead>
                    <tr>
                        <th>Sr No</th>
                        <th>Warehouse name</th>
                        <th>Warehouse Location</th>
                        <th>Remaining Quantity</th>
                        <th>Reallocation qty</th>
                    </tr>

                </thead>
                <tbody>
                    <tr> 
                        <td><input
                            id={checkboxId}
                            type="checkbox"
                            checked={selected?.has(item.batch_number)}
                            onChange={() => toggleItem(item.batch_number)}
                          /></td>
                        <td>{item.warehouse_name}</td>  
                        <td>{item.warehouse_location}</td>
                        <td>{item.remaining_quantity}</td>
                         <th>
                          <input
                      type="number"
                      disabled={!selected.has(item.batch_number)}
                      // value={ allocatedQty[item.batch_number]?.value || ""}
                      value={
                          item.remaining_quantity >= (allocatedQty[item.batch_number]?.value ?? 0)
                            ? allocatedQty[item.batch_number]?.value ?? ""
                            : ""
                        }

                      onChange={(e) =>
                        handleQtyChange(
                          item.batch_number,
                          e.target.value,
                          item.warehouse_location
                        )
                      }
                    />
                       </th>
                    </tr>       

                </tbody>
            </table>
            
            {/* <span>{item.warehouse_location}  && {item.remaining_quantity}</span> */}
          </label>
        );
      })}
    </div>
  );
}